module.exports = __webpack_public_path__ + "static/media/madpaws.a4c5c904.png";